import { Route, Routes } from "react-router-dom";

import "./assets/fonts/stylesheet.css"
import "./assets/css/common.scss"
import "./assets/css/style.scss"
import "./assets/css/style2.scss"
import "./assets/css/style3.scss"
import "./assets/css/custom.scss"
import Home from "./view/pages/Home/Home";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
  );
}

export default App;
